export function deepCopy(json={}){
    return JSON.parse(JSON.stringify(json));
}